import React from 'react';
import UserManagement from '../components/UserManagement';

const UserManagementPage = ({ user }) => {
  return <UserManagement user={user} />;
};

export default UserManagementPage;
